export const settings = JSON.parse(document.getElementById('conf').textContent);
export default settings
